import styled from "styled-components";

export const PageCardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(${({ columns }) => columns}, minmax(0, 1fr));
  grid-auto-rows: 1fr;
  width: 100%;
  gap: 16px;
`;

export const PageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

export const Link = styled.a`
  all: unset;
  cursor: pointer;

  & > div:first-of-type {
    height: 100%;
    box-sizing: border-box;
  }
`;
